import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPreapprovaldeniedbadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#C00"
        d="M8.275 21.525 6.8 19.1l-2.75-.625a.9.9 0 0 1-.55-.337.79.79 0 0 1-.15-.613L3.6 14.7l-1.875-2.1A.93.93 0 0 1 1.5 12q0-.326.225-.6L3.6 9.3l-.25-2.825a.79.79 0 0 1 .15-.612.9.9 0 0 1 .55-.338L6.8 4.9l1.475-2.425a.94.94 0 0 1 .487-.387.9.9 0 0 1 .638.012L12 3.225 14.6 2.1a.9.9 0 0 1 .638-.012q.312.113.487.387L17.2 4.9l2.75.625q.35.075.55.338.2.262.15.612L20.4 9.3l1.875 2.1q.225.274.225.6a.93.93 0 0 1-.225.6L20.4 14.7l.25 2.825a.79.79 0 0 1-.15.613.9.9 0 0 1-.55.337l-2.75.625-1.475 2.425a.94.94 0 0 1-.487.388.9.9 0 0 1-.638-.013L12 20.775 9.4 21.9a.9.9 0 0 1-.638.013.94.94 0 0 1-.487-.388m1.125-1.6 2.6-1.1 2.6 1.1 1.45-2.425 2.75-.625-.25-2.775L20.4 12l-1.85-2.1.25-2.775-2.75-.625-1.45-2.425-2.6 1.1-2.6-1.1L7.95 6.5l-2.75.6.25 2.8L3.6 12l1.875 2.1-.275 2.8 2.75.625zM12 16.8q.375 0 .637-.262a.87.87 0 0 0 .263-.638.87.87 0 0 0-.263-.637A.87.87 0 0 0 12 15a.87.87 0 0 0-.637.263.87.87 0 0 0-.263.637q0 .375.263.638A.87.87 0 0 0 12 16.8m0-3.6q.375 0 .637-.262a.87.87 0 0 0 .263-.638V8.1a.87.87 0 0 0-.263-.637A.87.87 0 0 0 12 7.2a.87.87 0 0 0-.637.263.87.87 0 0 0-.263.637v4.2q0 .375.263.638A.87.87 0 0 0 12 13.2"
      />
    </g>
  </svg>
);
export default SvgPreapprovaldeniedbadge;
